export class FetchExcludeMicaPageLength {
  static readonly type = '[number] Fetch All';

  constructor(public payload: number) {
  }
}
